import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { env } from '@/config/env';
import { useAdminLayout } from '@/app/layouts';
import { useNavigation } from '@/app/layouts';

export function Sidebar() {
  const location = useLocation();
  const { sidebarOpen, closeSidebar } = useAdminLayout();
  const navigation = useNavigation();

  return (
    <>
      {/* Sidebar */}
      <aside
        className={cn(
          'fixed left-0 top-0 z-40 h-screen w-64 border-r bg-card transition-transform duration-300 lg:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="flex h-full flex-col">
          <div className="flex h-16 items-center justify-between border-b px-6">
            <h1 className="text-xl font-bold">{env.APP_NAME}</h1>
            {/* Close button for mobile */}
            <Button variant="ghost" size="icon" className="lg:hidden" onClick={closeSidebar}>
              <X className="h-5 w-5" />
              <span className="sr-only">Cerrar menú</span>
            </Button>
          </div>
          <nav className="flex-1 space-y-1 p-4">
            {navigation.map((item) => {
              // For root path, use exact match; for others, use startsWith to match child routes
              const isActive = item.href === '/' ? location.pathname === '/' : location.pathname.startsWith(item.href);
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={closeSidebar}
                  className={cn(
                    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                  )}
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-30 bg-foreground/50 lg:hidden" onClick={closeSidebar} aria-hidden="true" />
      )}
    </>
  );
}
